// Configuración de categorías y publicaciones multi-tenant
// Cada institución tiene su propia estructura de categorías y publicaciones.
// Catálogo legado: sólo lo usa la ruta /viewer (App.js) y tools/mostrar-rutas.js.

// ========================================
// PUBLICACIONES POR INSTITUCIÓN
// ========================================

const publicationsByInstitution = {
  // --- LICEO SALAZAR Y HERRERA ---
  liceo: {
    'documentos-institucionales': {
      id: 'documentos-institucionales',
      name: 'Documentos Institucionales',
      description: 'Documentos oficiales y normativos de la institución',
      magazines: [
        {
          id: 'manual-convivencia',
          title: 'Manual de Convivencia',
          pdfUrl: '/pdfs/manual-convivencia-2026.pdf',
          description: 'Manual de convivencia institucional',
        },
        {
          id: 'proyecto-inclusion',
          title: 'Proyecto de Inclusión',
          pdfUrl: '/pdfs/proyecto-inclusion-lsyh-2026.pdf',
          description: 'Proyecto de inclusión educativa',
        },
        {
          id: 'sistema-evaluacion',
          title: 'Sistema Institucional de Evaluación',
          pdfUrl: '/pdfs/siee-2026.pdf',
          description: 'Sistema institucional de evaluación de los estudiantes',
        },
        {
          id: 'textos-utiles-escolares',
          title: 'Lista de Textos y Útiles Escolares',
          pdfUrl: '/pdfs/lista-textos-utiles-escolares-2026.pdf',
          description: 'Lista de textos y útiles escolares requeridos',
        },
      ]
    },
    // Agregar más categorías del Liceo aquí...
  },

  // --- IUSH (INSTITUCIÓN UNIVERSITARIA) ---
  iush: {
    'boletines-pastoral': {
      id: 'boletines-pastoral',
      name: 'Boletines Pastoral',
      description: 'Boletines semanales de pastoral',
      magazines: [
        {
          id: 'vol12-n430',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n430.pdf',
          description: 'Boletín Pastoral Vol.12 N.430',
        },
        {
          id: 'vol12-n431',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n431.pdf',
          description: 'Boletín Pastoral Vol.12 N.431',
        },
        {
          id: 'vol12-n432',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n432.pdf',
          description: 'Boletín Pastoral Vol.12 N.432',
        },
        {
          id: 'vol12-n433',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n433.pdf',
          description: 'Boletín Pastoral Vol.12 N.433',
        },
        {
          id: 'vol12-n434',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n434.pdf',
          description: 'Boletín Pastoral Vol.12 N.434',
        },
        {
          id: 'vol12-n435',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n435.pdf',
          description: 'Boletín Pastoral Vol.12 N.435',
        },
        {
          id: 'vol12-n436',
          title: 'Edición más reciente',
          pdfUrl: '/pdfs/boletines-pastoral/vol12-n436.pdf',
          description: 'Boletín Pastoral Vol.12 N.436',
        },
       
      ]
    },
    'documentos-institucionales': {
      id: 'documentos-institucionales',
      name: 'Documentos Institucionales',
      description: 'Reglamentos, estatutos y documentos oficiales de la universidad',
      magazines: [
        // Agregar documentos institucionales de IUSH aquí:
        {
          id: 'portafolio-servicios-2026',
          title: 'Portafolio de Servicios 2026',
          pdfUrl: '/pdfs/portafolio-servicios/portafolio-servicios-2026.pdf',
          description: 'Portafolio de servicios vigente',
        },
        {
          id: 'historieta-sete-pai-1',
          title: 'Historieta Sete PAI 1',
          pdfUrl: '/pdfs/historietas-sete-pai/historieta-sete-pai-1.pdf',
          description: 'historieta educativa sobre la etica y valores morales',
        },
        {
          id: 'historieta-sete-pai-2',
          title: 'Historieta Sete PAI 2',
          pdfUrl: '/pdfs/historietas-sete-pai/historieta-sete-pai-2.pdf',
          description: 'historieta educativa sobre la etica y valores morales',
        },
      ]
    },
    'revistas-academicas': {
      id: 'revistas-academicas',
      name: 'Revistas Académicas',
      description: 'Publicaciones académicas y de investigación',
      magazines: [
        // Agregar revistas académicas de IUSH aquí:
        // {
        //   id: 'revista-investigacion-2026',
        //   title: 'Revista de Investigación 2026',
        //   pdfUrl: '/pdfs/revista-investigacion-2026.pdf',
        //   description: 'Edición anual de investigación',
        // },
      ]
    },
    // Agregar más categorías de IUSH aquí...
  },
};

// ========================================
// DETECCIÓN DE INSTITUCIÓN ACTIVA
// ========================================

// La institución ya no viene de la compilación: quien necesite el catálogo legado pasa el slug
// resuelto en ejecución (ver InstitucionContext); sin slug se conserva el valor histórico.
const getActiveInstitution = () => 'liceo';

const getActivePublications = (institution = getActiveInstitution()) => {
  return publicationsByInstitution[institution] || publicationsByInstitution.liceo;
};

// ========================================
// FUNCIONES PÚBLICAS (API)
// ========================================

// Función para obtener todas las categorías de la institución activa
export const getAllCategories = () => {
  return Object.values(getActivePublications());
};

// Función para obtener una categoría por ID
export const getCategoryById = (categoryId) => {
  return getActivePublications()[categoryId] || null;
};

// Función para obtener una revista por ID de categoría y revista
export const getMagazineById = (categoryId, magazineId) => {
  const category = getActivePublications()[categoryId];
  if (!category) return null;
  return category.magazines.find(mag => mag.id === magazineId) || null;
};

// Función para obtener todas las revistas de una categoría
export const getMagazinesByCategory = (categoryId) => {
  const category = getActivePublications()[categoryId];
  return category ? category.magazines : [];
};

// Función para obtener todas las revistas (para compatibilidad)
export const getAllMagazines = () => {
  return Object.values(getActivePublications()).flatMap(cat => 
    cat.magazines.map(mag => ({ ...mag, category: cat.id, categoryName: cat.name }))
  );
};

// ID por defecto (primera categoría y primera revista)
export const getDefaultMagazineId = (institution) => {
  const categories = Object.values(getActivePublications(institution));
  if (categories.length > 0 && categories[0].magazines.length > 0) {
    return {
      categoryId: categories[0].id,
      magazineId: categories[0].magazines[0].id
    };
  }
  return null;
};

// Exportar estructura completa para debugging/admin (opcional)
export { publicationsByInstitution };

export default getActivePublications();
